import { render, staticRenderFns } from "./RbuSection.vue?vue&type=template&id=75701d1a"
import script from "./RbuSection.vue?vue&type=script&lang=js"
export * from "./RbuSection.vue?vue&type=script&lang=js"
import style0 from "./RbuSection.vue?vue&type=style&index=0&id=75701d1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports